<div class="chip-list-item" [ngClass]="chipConfig.styleClass">
    <span *ngIf="chipConfig.chipBig" class="chip-list-item__pill">
        {{ chipConfig.pill }}
    </span>
    <span
        class="chip-list-item__text"
        [ngClass]="{ 'chip-list-item__text--center': chipConfig.chipBig }"
    >
        {{ chipConfig.role }}
    </span>
    <span
        class="chip-list-item__text text-trunc"
        [ngClass]="{ 'chip-list-item__text--center': chipConfig.chipBig }"
    >
        {{ chipConfig.name }}
    </span>
    <span
        class="material-icons chip-list-item__x-button"
        (click)="chipConfig.actionCallback(chipConfig.pill)"
    >
        cancel
    </span>
</div>
